<template>
<div class="bottomlink yo-text-n " style="margin:20px 0 0 0;padding:0;">


   <!-- senza spazio ai lati 
   <div style="max-width:1340px;margin:0 -22px 0 -22px;">
   -->
   <div style="max-width:1280px;margin:0 auto;">
    <div class="row">
       <!-- ELiminato su richiesta di Matteo in data 14 ottobre 2020
      <div class="col s12 m3" style="height:80px;">
            <a href="/645-2/">
            <div class="yo-bg-cover" style="height:100%;max-width:280px;margin:0 auto;" :style="{'background-image': `url(${require('../assets/bottom-bmtravel.png')})`}"  >
            <div class="white" style="padding:0 0 0 80px">
               <div class="yo-align-center yo-valign-text-bottom yo-text-bold" style="height:42px;">BioMedia Travel</div>
               <div class="yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:36px;">viaggia con noi</div>
            </div>
            </div>     
            </a>   
      </div>
      -->
      <div class="col s12 m3" style="height:80px;">
            <a href="/home/645-2/">
            <div class="yo-bg-cover" style="height:100%;max-width:280px;margin:0 auto;" :style="{'background-image': `url(${require('../assets/bottom-bmpressroom.png')})`}"  >
            <div class="white" style="padding:0 0 0 80px">
               <div class="yo-align-center yo-valign-text-bottom yo-text-bold" style="height:42px;">Press Room</div>
               <div class="yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:36px;">Comunicati stampa</div>
            </div>
            </div>     
            </a>   
      </div>

  

      <div class="s12 yo-hidden yo-show-phone">&#160;<br /><br />&#160;</div>
      <div class="col s12 m3" style="height:80px;">
            <a href="/970-2/">
            <div class="yo-bg-cover" style="height:100%;max-width:280px;margin:0 auto;" :style="{'background-image': `url(${require('../assets/bottom-bmcongressi.png')})`}"  >
            <div class="white" style="padding:0 0 0 80px">
               <div class="yo-align-center yo-valign-text-bottom yo-text-bold" style="height:42px;">BioMedia<br />Centro Congressi</div>
               <div class="yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:36px;">contatti</div>
            </div>
            </div>   
            </a>     
      </div>
      <div class="s12 yo-hidden yo-show-phone">&#160;<br /><br />&#160;</div>
      <div class="col s12 m3" style="height:80px;">
            <a href="/info/">
            <div class="yo-bg-cover" style="height:100%;max-width:280px;margin:0 auto;" :style="{'background-image': `url(${require('../assets/bottom-bminfo.png')})`}"  >
            <div class="white" style="padding:0 0 0 80px">
               <div class="yo-align-center yo-valign-text-bottom yo-text-bold" style="height:42px;">BioMedia Info</div>
               <div class="yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:36px;">richiedi un preventivo</div>
            </div>
            </div>  
            </a>   
      </div> 
      <div class="s12 yo-hidden yo-show-phone">&#160;<br /><br />&#160;</div> 
      <div class="col s12 m3" style="height:80px;">
            <router-link to="/nl-edit">
            <div class="yo-bg-cover" style="height:100%;max-width:280px;margin:0 auto;" :style="{'background-image': `url(${require('../assets/bottom-bmnewsletter.png')})`}"  >
            <div class="white" style="padding:0 0 0 80px">
               <div class="yo-align-center yo-valign-text-bottom yo-text-bold" style="height:42px;">&#160;</div>
               <div class="yo-align-center yo-valign-text-center yo-text-s yo-text-bold" style="height:36px;">newsletter</div>
            </div>
            </div>
            </router-link>      
      </div>
      <div class="s12 yo-hidden yo-show-phone">&#160;<br /><br />&#160;</div>
      
    </div>
  </div>


  <div style="max-width:1020px;margin:30px auto 0 auto;">
         <div class=" row vpad pad yo-text-s">
            <div class="top-menu col s12 m3"><a href="https://goo.gl/forms/ljK3UNfGBoVK3VKc2" target="_blank">Lavora con noi</a></div>
            <div class="top-menu col s12 m3"><a href="/privacy-policy/">Privacy Policy</a></div>
            <div class="top-menu col s12 m3"><a href="/contatti/">Come raggiungerci</a></div>
            <div class="col s12 m3 yo-spacing-s">

               <div class="social-link row">
                  <div class="col s12 text-align-right">
                  <a href="https://www.instagram.com/explore/locations/1046233395409686/biomedia-srl/" target="_blank"><img src="../assets/ico-istagram.png"></a>
                  <!-- <a href="https://www.youtube.com/channel/UCLpYo9jPV4gbrQhaXlmH5YQ" target="_blank"><img src="../assets/ico-youtube.png"></a> -->
                  <a href="https://www.facebook.com/biomediasrl" target="_blank"><img src="../assets/ico-facebook.png"></a> 
                  
                  <!--
                     <a href="https://twitter.com/hyperouranios" target="_blank"><img src="../assets/twitter.png"></a>
                  <a href="https://plus.google.com/XXX" target="_blank"><img src="../assets/googleplus.png"></a>
                  <a href="https://www.linkedin.com/company/XXXX" target="_blank"><img src="../assets/linkedin.png"></a>
                  <a href="https://www.weibo.com/XXXXX" target="_blank"><img src="../assets/weibo.png"></a>
                  -->
                  </div>
               </div>

    <!--
               <div class="top-menu row pad yo-text-s">
                  <div class="col s4 m2 offset-m6"><a href="/">@@</a></div>
                  <div class="col s4 m2"><a href="/">@@</a></div>
                  <div class="col s4 m2"><a href="/">@@</a></div>
               </div>
   -->
            </div>
         </div>

    </div>


   
</div>
</template>

<script>



export default {
   name: 'home',
   components: {

   }
}
</script>


<style>
.bottomlink .top-menu a{
   color:#ffffff;
   background:#379EC2;
   display:block;
   font-weight:bold;
   margin-left:0;
   text-align:center;
   line-height:34px;  
   height:35px;  
}.bottomlink .top-menu a:hover{
   background-color:#0D1B3B;
   color:#379EC2;
}.bottomlink .top-menu a:last-child{
   /*margin-right:0;*/
}.bottomlink a.button i, .footer-bottom a.button i{
    line-height: 40px;
    height: 40px;
    font-size: 3.2rem;
}.social-link a{
    float:right;
    background:#379EC2;
    margin-left:8px;
    height:35px;  
    overflow:hidden;
}
.social-link a img {
    height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/Bottomlink.vue